import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import Resources from './Resources.js';
import DashBoard from './DashBoard.js';
import KUOS from './KUOS.js';
import NIA_AI from './NIA_AI_Service.js';
import Wait_page from '../Wait_page.js';
function Resources_home({ match }) {
	const Page = match.params.name;
	if (Page == 'Resources') {
		return <Resources />;
	} else if (Page == 'KUOS') {
		return <Wait_page />;
	} else if (Page == 'NIA_AI') {
		return <NIA_AI />;
	} else {
		return <div>404 페이지를 찾을 수 없습니다. </div>;
	}
}

export default Resources_home;
